export default {"src":"/_next/static/media/pci-dss-compliance-reporting.d7110bcb.svg","height":380,"width":286,"blurWidth":0,"blurHeight":0};